window.__assetPrefix__ = 'https://mf-legal-static.crehana.com/legals-mf';